import { render, staticRenderFns } from "./DSUploadIcon.vue?vue&type=template&id=f9c66638&scoped=true&"
import script from "./DSUploadIcon.vue?vue&type=script&lang=js&"
export * from "./DSUploadIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f9c66638",
  null
  
)

export default component.exports